import { User } from 'generate/types';

export function getIsVerified(verified: User['verified'],) {
	return verified ? verified:false;
}
